import { Button } from "react-bootstrap";
import useDisclosure from "../../../hook/useDisclosure";
import MedicalRecordEditModal from "./medical-record-edit-modal";

const AddMedicalRecordButton = () => {
	const { opened, open, close } = useDisclosure();

	return (
		<div>
			<Button
				className="btn-fill spaces px-16"
				onClick={() => {
					open();
				}}
			>
				Thêm mới bệnh án
			</Button>
			{opened && <MedicalRecordEditModal open={opened} onClose={close} />}
		</div>
	);
};

export default AddMedicalRecordButton;
